import { AfterViewInit, Component, inject, OnDestroy, OnInit, viewChild } from '@angular/core';
import { MatTab, MatTabContent, MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';

import { Subscription } from 'rxjs';

import { Auditor } from '../../models/auditor';
import { AuditTableComponent } from '../audit-detail/audit-table/audit-table.component';
import { HeaderComponent } from '../header/header.component';
import { RecommendationTableComponent } from '../recommendation-detail/recommendation-table/recommendation-table.component';

@Component({
  selector: 'app-rec-and-audits-tab',
  templateUrl: './rec-and-audits-tab.component.html',
  styleUrls: ['./rec-and-audits-tab.component.scss'],
  imports: [HeaderComponent, MatTabGroup, MatTab, MatTabContent, RecommendationTableComponent, AuditTableComponent]
})
export class RecAndAuditsTabComponent implements OnInit, OnDestroy, AfterViewInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  area!: string;
  readonly tabs = viewChild.required(MatTabGroup);
  subs: Subscription[] = [];
  nav!: string;
  loaded = true;

  ngOnInit() {
    this.area = this.route.snapshot.params.area;
    this.nav = this.area === Auditor.GPIA ? '1' : '2';
  }

  ngAfterViewInit() {
    switch (this.route.snapshot.url[0].path) {
      case 'recommendations':
        this.tabs().selectedIndex = 0;
        break;
      case 'audits':
        this.tabs().selectedIndex = 1;
        break;
      case 'recommendations-all':
        this.tabs().selectedIndex = 2;
        break;
      case 'audits-all':
        this.tabs().selectedIndex = 3;
        break;
    }
    this.subs.push(this.route.url.subscribe({ next: (url) => this.updateRoute(url) }));
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  changeTab(evn: number) {
    let path = '';
    switch (evn) {
      case 0:
        path = 'recommendations';
        break;
      case 1:
        path = 'audits';
        break;
      case 2:
        path = 'recommendations-all';
        break;
      case 3:
        path = 'audits-all';
        break;
    }
    this.router.navigate([path, this.area]);
  }

  updateRoute(url: UrlSegment[]) {
    const newArea = url[1].path;
    if (this.area !== newArea) {
      this.area = newArea;
    }
  }
}
